<template>
  <div>
    <hint-page v-if="showHint" @close="playVideo">
      <br />Video is ready, close to begin
    </hint-page>
    <video width="768" height="768" ref="video" playsinline preload="metadata">
      <slot></slot>
      <p>format not supported in this browser</p>
    </video>
  </div>
</template>

<script>
import HintPage from "../pages/HintPage";

export default {
  components: { HintPage },
  data: function() {
    return {
      showHint: false
    };
  },
  methods: {
    playVideo() {
      this.showHint = false;
      this.$refs.video.play();
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$refs.video
        .play()
        .then(() => {
          console.log("video started playing automatically");
        })
        .catch(error => {
          console.log(
            "Video couldn't play automatically, mute & show controls first"
          );
          // try again, but this time muted
          // this.$refs.video.muted = true;
          // this.$refs.video.controls = true;
          // this.$refs.video.play();

          // Show UI so user will click to start video playback
          this.showHint = true;
        });
    });
  }
};
</script>

